<template>
    <div>
        <!-- v-model="incidentNo" -->
        <BaseAutoComplete
            label="Incident Number"
            placeholder="Enter an incident number"
            :suggestions="allIncidentNumbers"
            @item-select="populateIncidentData"
            @complete="filterIncidentNumbers"
            :errorMessage="errorMessage"
            :class="{ 'p-invalid': errorMessage }"
        />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { incidentStore } from '../../../../../store/global-stores';

const emit = defineEmits(['disable-date-change', 'update:modelValue']);

defineProps({
    modelValue: {
        type: String,
    },
    errorMessage: {
        type: String,
    },
});

const { incident, incidents } = storeToRefs(incidentStore);

// const incidentNo = ref(null); // It has no usage at the moment
const allIncidentNumbers = ref([]);

const filterIncidentNumbers = async (data) => {
    emit('update:modelValue', data);
    setTimeout(async () => {
        await loadIncidents(data);
        // incidents are loaded into incidents on store
        // so map them accordingly into the allIncidentNumbers with only the incidents
        allIncidentNumbers.value = incidents.value?.filter((item) => item.incident_number)?.map((item) => item.incident_number);
        // Make sure to emit disableDate false
        // disableIncidentDate.value = false;
        emit('disable-date-change', false);
    }, 250);
};

const populateIncidentData = (incident_number) => {
    let date = incidents.value.find((item) => item.incident_number == incident_number)?.incident_date;
    incident.value.incident_date = date ?? null;
    // After populating the incident details
    // Make sure to emit disableDate true
    emit('disable-date-change', true);
    emit('update:modelValue', incident_number);
};

const loadIncidents = async (data) => {
    await incidentStore.fetchIncidentList(data);
};
</script>
